var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.625 7.75H5.375a.46.46 0 0 1-.281-.094A.46.46 0 0 1 5 7.375v-1q0-.156.094-.25A.4.4 0 0 1 5.375 6h13.25q.156 0 .25.125a.3.3 0 0 1 .125.25v1a.4.4 0 0 1-.125.281.34.34 0 0 1-.25.094m0 5H5.375a.46.46 0 0 1-.281-.094.46.46 0 0 1-.094-.281v-1q0-.156.094-.25A.4.4 0 0 1 5.375 11h13.25q.156 0 .25.125a.3.3 0 0 1 .125.25v1a.4.4 0 0 1-.125.281.34.34 0 0 1-.25.094m0 5H5.375a.46.46 0 0 1-.281-.094.46.46 0 0 1-.094-.281v-1q0-.156.094-.25A.4.4 0 0 1 5.375 16h13.25q.156 0 .25.125a.3.3 0 0 1 .125.25v1a.4.4 0 0 1-.125.281.34.34 0 0 1-.25.094"
  })));
};
export default SvgMenu;